module.exports = __webpack_public_path__ + "img/2-threeImg.1963f570.png";